import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import axios from 'axios'
import { isSuperuser, hasPermission } from './utils/auth'
import { QuillEditor } from '@vueup/vue-quill'
import '@vueup/vue-quill/dist/vue-quill.snow.css'
import { ElMessage } from 'element-plus'

const app = createApp(App)

// 全局图标注册
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}

// 插件注册
app.use(store)
app.use(router)
app.use(ElementPlus)

// 全局域名配置
const baseUrl = ''
// 关键修复：给axios设置基础地址，所有请求自动拼接后端域名
axios.defaults.baseURL = baseUrl
app.config.globalProperties.apiUrl = baseUrl
app.config.globalProperties.$http = axios
window.$http = axios

// 请求拦截器
axios.interceptors.request.use(function (config) {
  const token = typeof window !== 'undefined' ? localStorage.getItem('adminToken') : ''
  config.headers.Authorization = token
  return config
}, function (err) {
  return Promise.reject(err)
})

// 响应拦截器
axios.interceptors.response.use(function (res) {
  if (res.data.code === 403) {
    ElMessage.error("请先登录");
    router.push('/login');
    return Promise.reject(res)
  }
  return res
}, function (err) {
  console.error('请求错误详情:', err.response || err);
  if (err.response) {
    const status = err.response.status;
    const data = err.response.data;
    if (status === 401) {
      ElMessage.error("登录已过期，请重新登录");
      router.push('/login');
    } else if (status === 403) {
      ElMessage.error("权限不足，无法访问");
    } else {
      ElMessage.error(`请求失败（${status}）: ${data?.message || '服务器错误'}`);
    }
  } else {
    ElMessage.error("网络错误，无法连接服务器");
  }
  return Promise.reject(err);
})

// 权限指令
app.directive('permission', {
  mounted(el, binding) {
    if (isSuperuser()) return
    if (!hasPermission(binding.value)) {
      el.style.display = 'none'
    }
  }
})

// 富文本全局组件
app.component('QuillEditor', QuillEditor)

app.mount('#app')